<template>
  <div>
    <b-form-group>
      <div class="d-flex flex-column">
        <div class="label-type-2 mb-3">Order Notification</div>
        <span class="mr-2 mb-2">Receive Order Notifications via email?</span>
        <b-form-radio-group
          v-model="selectedValue.enable"
          @change="debouncedForceUpdate()"
          id="is-email-enabled">
          <b-form-radio :value="true">Yes</b-form-radio>
          <b-form-radio :value="false">No</b-form-radio>
        </b-form-radio-group>
      </div>
    </b-form-group>
    <b-form-group label="Send this via this email" label-class="grey">
      <b-row class="mb-3" v-for="(emailItem, emailIndex) in selectedValue.emails" :key="`notif-email-${emailIndex}`">
        <b-col sm="8" lg="4">
          <b-form-input
            placeholder="Enter Email Address"
            :value="emailItem"
            @input="handleChangeEmail($event, emailIndex)"
            :state="isInvalid(`order_notification.email.${emailIndex}`)"
            :disabled="!selectedValue.enable">
          </b-form-input>
          <b-form-invalid-feedback :force-show="isInvalid(`order_notification.email.${emailIndex}`)">
            {{ errorMessage(`order_notification.email.${emailIndex}`) }}
          </b-form-invalid-feedback>
        </b-col>
        <b-col sm="4" lg="2">
          <b-button
            v-if="selectedValue.emails.length > 1"
            variant="ghost" class="remove-email p-0 rounded-circle mr-2"
            @click="handleRemoveEmail(emailIndex)"
            :disabled="!selectedValue.enable">
            <img src="../../assets/images/u_trash-alt.svg" alt="Remove Email">
          </b-button>
          <b-button
            v-if="emailIndex === selectedValue.emails.length - 1"
            variant="primary" class="add-email p-0 m-0 rounded-circle"
            @click="handleAddEmail()"
            :disabled="selectedValue.emails.length === 3 || !selectedValue.enable">
            <img src="../../assets/images/plus-icon.svg" alt="Add Email">
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: "FulfillmentOrderNotification",
  props: ['selectedValue'],
  computed: {
    ...mapGetters({
      errors: 'orderFulfillment/errors'
    })
  },
  created() {
    this.debouncedForceUpdate = _.debounce(() => {
      this.$forceUpdate();
      this.setErrors(null);
      this.$emit('setOrderNotification', this.selectedValue);
      this.$root.$emit('changesDetected');
    }, 300);
  },
  methods: {
    ...mapMutations({
      setErrors: 'orderFulfillment/set_errors'
    }),
    handleChangeEmail(value, index) {
      this.selectedValue.emails[index] = value;
      this.debouncedForceUpdate();
    },
    handleAddEmail() {
      this.selectedValue.emails.push(null);
      this.debouncedForceUpdate();
    },
    handleRemoveEmail(emailIndex) {
      this.selectedValue.emails.splice(emailIndex, 1);
      this.debouncedForceUpdate();
    },
    isInvalid(key) {
      return this.errors && this.errors[key] ? false : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key] ? this.errors[key] : null;
    },
  }
}
</script>

<style lang="scss" scoped>
.btn.btn-primary.add-email,
.btn.remove-email {
  width: 38px;
  height: 38px;
}
</style>
